class ProductFaqTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this._setup();
    }

    disconnectedCallback() {
        if (this._tabs) {
            this._tabs.forEach((btn) => {
                btn.removeEventListener('click', btn.__faqHandler);
            });
        }
    }

    _setup() {

        this._tabs = Array.from(this.querySelectorAll('.faq-tab'));
        this._panels = Array.from(this.querySelectorAll('.faq-panel'));

        this._tabs.forEach((btn) => {
            var handler = () => {
                this._onTabClick(btn);
            };
            btn.addEventListener('click', handler);
        });
    }

    _onTabClick(btn) {
        var tabKey = btn.dataset.tab;
        if (!tabKey) return;
        if (btn.classList.contains('faq-tab--active')) return;

        this._tabs.forEach(function (t) {
            var active = t === btn;
            t.classList.toggle('faq-tab--active', active);
            t.setAttribute('aria-selected', String(active));
        });

        this._panels.forEach(function (panel) {
            panel.style.display = panel.dataset.panel === tabKey ? 'block' : 'none';
        });
    }
}

if (!customElements.get('product-faq-tabs')) {
    customElements.define('product-faq-tabs', ProductFaqTabs);
}